/**
 * 画面Form表示形式
 */
export const Appearance = {
  // 参照
  fill: 'fill',
  // 変更
  outline: 'outline',
} as const;

